import React from 'react';
// eslint-disable-next-line import/no-unresolved
import PlayerContainer from 'LocalGluons/components/PlayerContainer';
import { useStore } from 'Store';
import type { PlayerData } from 'Types';

const AppPlayer = (): JSX.Element => {
    const { playerData } = useStore();

    return playerData && <PlayerContainer playerData={playerData as PlayerData} />;
};

export default AppPlayer;
